import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';

export default function EquipmentDetailsPage() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { id } = useParams(); 
  const [equipment, setEquipment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entity, setEntity] = useState(null);
  const [subEntity, setSubEntity] = useState(null);
  const [category, setCategory] = useState(null);
  const [matrice, setMatrice] = useState(null);
  const [processType, setProcessType] = useState(null);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  useEffect(() => {
    const fetchEquipmentDetails = async () => {
      if (!id) return;
      setIsLoading(true);
      setError(null);

      try {
        // Busca os detalhes do equipamento
        const response = await fetch(`https://api.hub4food.colab4food.com/api/equipments/${id}`);
        if (!response.ok) {
          if (response.status === 404) {
            setEquipment(null);
            setError("Nenhum detalhe do equipamento encontrado.");
          } else {
            throw new Error('Erro ao buscar os detalhes do equipamento');
          }
        } else {
          const data = await response.json();
          setEquipment(data);

          // Busca os detalhes relacionados
          if (data.entity_id) {
            const entityResponse = await fetch(`https://api.hub4food.colab4food.com/api/entities/${data.entity_id}`);
            if (entityResponse.ok) {
              const entityData = await entityResponse.json();
              setEntity(entityData);
            }
          }

          if (data.sub_entity_id) {
            const subEntityResponse = await fetch(`https://api.hub4food.colab4food.com/api/sub-entities/${data.sub_entity_id}`);
            if (subEntityResponse.ok) {
              const subEntityData = await subEntityResponse.json();
              setSubEntity(subEntityData);
            }
          }

          if (data.category_id) {
            const categoryResponse = await fetch(`https://api.hub4food.colab4food.com/api/categories/${data.category_id}`);
            if (categoryResponse.ok) {
              const categoryData = await categoryResponse.json();
              setCategory(categoryData);
            }
          }

          if (data.matrice_id) {
            const matriceResponse = await fetch(`https://api.hub4food.colab4food.com/api/matrices/${data.matrice_id}`);
            if (matriceResponse.ok) {
              const matriceData = await matriceResponse.json();
              setMatrice(matriceData);
            }
          }

          if (data.process_type) {
            const processTypeResponse = await fetch(`https://api.hub4food.colab4food.com/api/process-types/${data.process_type}`);
            if (processTypeResponse.ok) {
              const processTypeData = await processTypeResponse.json();
              setProcessType(processTypeData);
            }
          }
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEquipmentDetails();
  }, [id]);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!equipment) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6">
          {error || "Equipamento não encontrado"}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Navbar */}
      <BurgerBar />

      {/* Main Content */}
      <Box sx={{ p: 3, maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img 
            src="/logocolab.png" 
            alt="Hub4Food Logo" 
            style={{ width: '80%', maxWidth: '120px' }} 
          />
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {equipment.equipment_name}
          </Typography>
        </Box>

        {/* Tabs */}
        <Paper sx={{ mb: 3 }}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Equipment Details" />
            <Tab label="Technical Specifications" />
            <Tab label="Related Information" />
          </Tabs>
        </Paper>

        {/* Equipment Details */}
        {selectedTab === 0 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Entity"
                  value={entity ? entity.name : 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Sub-Entity"
                  value={subEntity ? subEntity.name : 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Category"
                  value={category ? category.category_name : 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Process Type"
                  value={processType ? processType.description : 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Applications"
                  value={equipment.applications || 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          </Paper>
        )}

        {/* Technical Specifications */}
        {selectedTab === 1 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Main Specifications"
                  value={equipment.main_specs || 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={5}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Scales"
                  value={equipment.scales || 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Observations"
                  value={equipment.observations || 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={3}
                />
              </Grid>
            </Grid>
          </Paper>
        )}

        {/* Related Information */}
        {selectedTab === 2 && (
          <Paper elevation={3} sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Related Matrice"
                  value={matrice ? `${matrice.matrice_name} - ${matrice.observations || 'No details'}` : 'N.A'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={2}
                />
              </Grid>
              {entity && (
                <Grid item xs={12}>
                  <Button 
                    variant="outlined" 
                    fullWidth
                    onClick={() => navigate(`/detailedentities/${entity.id}`)}
                  >
                    View Entity Details: {entity.name}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Paper>
        )}
      </Box>

      <Footer/>

    </Box>
  );
}